import "whatwg-fetch";
import { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { DatePicker } from "@material-ui/pickers/DatePicker";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import PropTypes from "prop-types";

export default class DateFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  openPopup = () => {
    this.setState({ open: true });
  };

  closePopup = () => {
    this.setState({ open: false });
  };

  blurDateFilter = (fromDate, toDate) => {
    this.props.filter({ fromDate, toDate });
  };

  handleChangeFromDate = (date) => {
    let { filterValue } = this.props;
    this.blurDateFilter(date, filterValue.toDate);
  };

  handleChangeToDate = (date) => {
    let { filterValue } = this.props;
    this.blurDateFilter(filterValue.fromDate, date);
  };

  clearFilters = () => {
    this.blurDateFilter();
  };

  render() {
    let { filterValue } = this.props;
    let appliedFilter = !!(filterValue.fromDate || filterValue.toDate);

    let actions = [
      <Button
        key="1"
        variant="contained"
        color="primary"
        onClick={this.clearFilters}
        style={{ float: "left" }}
      >
        Clear Filters
      </Button>,
      <Button
        key="2"
        variant="contained"
        color="primary"
        onClick={this.closePopup}
      >
        Close
      </Button>,
    ];

    return (
      <div>
        <div onClick={this.openPopup} className="table-filter-button">
          {appliedFilter ? (
            <b>
              <SearchIcon
                style={{
                  verticalAlign: "text-bottom",
                  height: "12px",
                  width: "12px",
                }}
              />{" "}
              Filter Applied
            </b>
          ) : (
            "Click to filter"
          )}
        </div>
        <Dialog open={this.state.open}>
          <DialogContent>
            <div>
              <DatePicker
                inputVariant="outlined"
                className="small-datepicker"
                helperText="From"
                format="YYYY/MM/DD"
                mode="landscape"
                onChange={this.handleChangeFromDate}
                value={filterValue.fromDate}
              />
            </div>
            <div>
              <DatePicker
                inputVariant="outlined"
                className="small-datepicker"
                helperText="To"
                format="YYYY/MM/DD"
                mode="landscape"
                onChange={this.handleChangeToDate}
                value={filterValue.toDate}
              />
            </div>
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }

  static propTypes = {
    filterValue: PropTypes.object,
    filter: PropTypes.func,
  };
}
